import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/landing-mobile.jpg'
import _imports_1 from '@/assets/images/landing-mobile@2x.jpg'
import _imports_2 from '@/assets/images/landing-desktop.jpg'
import _imports_3 from '@/assets/images/landing-desktop@2x.jpg'


const _withScopeId = n => (_pushScopeId("data-v-53f3d028"),n=n(),_popScopeId(),n)
const _hoisted_1 = _imports_0 + ' 1x, ' + _imports_1 + ' 2x'
const _hoisted_2 = _imports_2 + ' 1x, ' + _imports_3 + ' 2x'
const _hoisted_3 = { class: "quit" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("picture", { class: "background" }, [
  /*#__PURE__*/_createElementVNode("source", {
    srcset: _hoisted_1,
    media: "(max-width: 1024px)"
  }),
  /*#__PURE__*/_createElementVNode("source", { srcset: _hoisted_2 }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "",
    loading: "lazy"
  })
], -1))
const _hoisted_5 = { class: "panel" }
const _hoisted_6 = { class: "panel-body" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "nav" }

import { computed } from 'vue';
import { useI18n } from 'vue-i18n'
import { useAppState, useNetworkState } from '@/services/composition';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n()
const nwState = useNetworkState()
const { state, send } = useAppState()


return (_ctx: any,_cache: any) => {
  const _component_ui_btn = _resolveComponent("ui-btn")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "long-fade",
    appear: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_Transition, {
          name: "medium-fade",
          mode: "out-in",
          appear: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('quit.title')), 1),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_ui_btn, {
                    variant: "secondary",
                    color: "light",
                    "border-position": "bottom-right",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(send)('GAME_BACK_HOME')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('quit.back')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ui_btn, {
                    variant: "secondary",
                    color: "light",
                    "border-position": "bottom-right",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(send)('REQUEST_SESSION')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('quit.continue')), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})